// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22V79","signatureBlock":"Footer_signatureBlock__aIc0H","signature":"Footer_signature__3z2NW"};